// Preserve server order while page boundaries move after a playlist is updated.
export function uniquePlaylists(items = []) {
  const seen = new Set();
  return items.filter((item) => {
    if (item?.id == null || seen.has(String(item.id))) return false;
    seen.add(String(item.id));
    return true;
  });
}
export function validatePlaylistPage(result, requestedPage) {
  const pagination = result?.meta?.pagination;
  if (
    !Array.isArray(result?.data) ||
    !Number.isInteger(pagination?.currentPage) ||
    pagination.currentPage !== requestedPage ||
    !Number.isInteger(pagination?.totalPages) ||
    pagination.totalPages < 0
  )
    throw new Error('Invalid playlist page');
  return { ...result, data: uniquePlaylists(result.data) };
}
export function nextPlaylistPage(page) {
  const p = page.meta.pagination;
  return p.currentPage < p.totalPages ? p.currentPage + 1 : undefined;
}
